import { Renderer } from '@unseenco/taxi';
import { viewStorage } from '../_globals'
import WknSwiper from '../modules/wkn-swiper'

export default class PageAntilles extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {
      qualitySwiper: viewStorage.current.querySelector('.Antilles-quality .swiper'),
      eventsSwiper: viewStorage.current.querySelector('.Antilles-events .swiper'),
      testimonialsSwiper: viewStorage.current.querySelector('.Antilles-testimonials .swiper')
    }

    this.init()
  }

  // fix #14291 / ticket audit-figma : les carrousels Qualités et Événements
  // débordent des 2 côtés (margin négatif dans _antilles.scss) — les offsets
  // recalent le 1er slide sur le container (106/1440 et 120/1440 du viewport).
  qualityOffset() {
    return window.innerWidth > 768 ? Math.round(window.innerWidth * 106 / 1440) : 0
  }

  eventsOffset() {
    return window.innerWidth > 768 ? Math.round(window.innerWidth * 120 / 1440) : 0
  }

  init() {
    const {
      qualitySwiper = null,
      eventsSwiper = null,
      testimonialsSwiper = null
    } = this.DOM

    if (qualitySwiper) this.qualitySwiperModule = new WknSwiper(qualitySwiper, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesOffsetBefore: this.qualityOffset(),
      slidesOffsetAfter: this.qualityOffset()
    })

    if (eventsSwiper) this.eventsSwiperModule = new WknSwiper(eventsSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      slidesOffsetBefore: this.eventsOffset(),
      slidesOffsetAfter: this.eventsOffset()
    })

    if (testimonialsSwiper) this.testimonialsSwiperModule = new WknSwiper(testimonialsSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 20
    })

    // BUG Sandro 29/07 : les offsets dépendent de innerWidth mais n'étaient
    // calculés qu'à l'init. Un Swiper créé en desktop (offset 120) puis réduit
    // — resize DevTools OU rotation du téléphone — gardait son offset : slide
    // décalée à droite, titre/texte/bouton « Inscription » coupés (mesuré :
    // translateX résiduel 120px après resize, 78px après rotation paysage->
    // portrait). Swiper re-layoute au resize (updateOnWindowResize) mais ne
    // recalcule jamais une config statique : on la recale ici puis update().
    this.onResize = () => {
      const maj = (mod, offset) => {
        const swiper = mod && mod.swiper
        if (!swiper || swiper.destroyed) return
        if (swiper.params.slidesOffsetBefore !== offset) {
          swiper.params.slidesOffsetBefore = offset
          swiper.params.slidesOffsetAfter = offset
          swiper.update()
        }
      }
      maj(this.qualitySwiperModule, this.qualityOffset())
      maj(this.eventsSwiperModule, this.eventsOffset())
    }
    window.addEventListener('resize', this.onResize, { passive: true })
    window.addEventListener('orientationchange', this.onResize, { passive: true })
  }

  onLeaveCompleted() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('orientationchange', this.onResize)
    this.qualitySwiperModule && this.qualitySwiperModule.destroy()
    this.eventsSwiperModule && this.eventsSwiperModule.destroy()
    this.testimonialsSwiperModule && this.testimonialsSwiperModule.destroy()
  }
}
